import { useEffect, useState } from 'react';
import type { Image } from 'types/capi/shared';

import ChevronIcon from '~/assets/icons/Chevron';

import ImageThumb from './ImageThumb';

type Props = {
  gallery: Image[];
  pad: boolean;
  setCurrentSlide: (index: number) => void;
};

export default function ImageThumbs({ gallery, setCurrentSlide, pad }: Props) {
  const [firstImageIndex, setFirstImageIndex] = useState(0);
  const DISPLAYED_THUMBS = 4;
  const lastImageIndex = Math.min(
    firstImageIndex + DISPLAYED_THUMBS,
    gallery.length
  );
  const shortenedGallery = gallery.slice(firstImageIndex, lastImageIndex);

  const isScrollUpDisabled = () => firstImageIndex === 0;

  const isScrollDownDisabled = () => lastImageIndex === gallery.length;

  const handleScrollUp = () => {
    if (!isScrollUpDisabled()) {
      setFirstImageIndex((current) => current - 1);
    }
  };

  const handleScrollDown = () => {
    if (!isScrollDownDisabled()) {
      setFirstImageIndex((current) => current + 1);
    }
  };

  useEffect(() => {
    setFirstImageIndex(0);
  }, [gallery]);

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <div className="rotate-180">
        <ScrollButton
          onClick={handleScrollUp}
          disabled={isScrollUpDisabled()}
        />
      </div>

      {shortenedGallery.map((image, index) => {
        const unshortenedGalleryIndex = index + firstImageIndex;

        return (
          <ImageThumb
            key={unshortenedGalleryIndex}
            image={image}
            index={unshortenedGalleryIndex}
            pad={pad}
            setCurrentSlide={setCurrentSlide}
          />
        );
      })}

      <ScrollButton
        onClick={handleScrollDown}
        disabled={isScrollDownDisabled()}
      />
    </div>
  );
}

type ScrollButtonProps = {
  disabled: boolean;
  onClick: () => void;
};

function ScrollButton({ onClick, disabled }: ScrollButtonProps) {
  return (
    <button
      className="size-fit disabled:opacity-30"
      disabled={disabled}
      onClick={onClick}
    >
      <ChevronIcon stroke="black" width="20" height="20" />
    </button>
  );
}
